import styled from "styled-components"
import {H3, Label} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import {minWidthMedia} from "@irati/ui/src/global/media"

export const StyledHeaderCard = styled(Card)`
  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);
`

export const InnerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  ${minWidthMedia.phoneLandscape`
    flex-direction: row;
  `}
`

export const ColumnWrapper = styled.div<{left?: boolean}>`
  text-align: center;
  width: 100%;
  ${minWidthMedia.phoneLandscape`
    width: 50%;
  `}
  ${({left}) => left && "text-align: left;"};
`

export const StyledCaption = styled(Label)`
  margin-top: 10px;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.greys.mediumDark};
`

export const AvailableBalance = styled(H3)`
  color: ${({theme}) => theme.colors.brand.default};
  font-size: 45px;
  line-height: 50px;
  padding-bottom: 20px;
  ${minWidthMedia.phoneLandscape`
    padding-bottom: 0px;
  `}
`
